module.exports = __webpack_public_path__ + "assets/img/thanks-letter-2020_prize-2.356aed83.png";